/**
 * @file   src\components\CWInput.tsx
 * @brief  Input with label component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { InputProperty } from '../interfaces/generalInterface';
import { InputGroup } from '../utils/thirdpartyComponents';
import "../components/CWInput.scss";

const CWInputGroup = ({
  onChange,
  onBlur,
  onFocus,
  onKeyPress,
  label,
  isMandatory,
  autoFocus,
  errorMessage,
  value,
  readOnly,
  id,
  name,
  type,
  accept,
  pattern,
  placeholder,
  disabled,
  maxLength,
  step,
  labelPrefix,
  labelSuffix
}: InputProperty) => {

  return (
    <div className="form-group cw-input">

      <div className="cust-label-group">
        <label htmlFor="label">
          {label}
          {labelSuffix ? <span className="label-suffix">{labelSuffix}</span> : ''}
          {isMandatory && <span className="mandatory">*</span>}
        </label>
        <InputGroup>
          <InputGroup.Text id="basic-addon1">{labelPrefix}</InputGroup.Text>
          <input
            className={errorMessage && errorMessage !== '' ? 'form-control error' : value !== '' ? 'form-control active' : 'form-control'}
            id={id}
            autoFocus={autoFocus}
            name={name}
            type={type}
            accept={accept}
            value={value}
            pattern={pattern}
            placeholder={placeholder}
            disabled={disabled}
            maxLength={maxLength}
            onChange={(event) => onChange && onChange(event)}
            onBlur={(event) => onBlur && onBlur(event)}
            step={step}
            onFocus={(event) => onFocus && onFocus(event)}
            onKeyDown={(event) => onKeyPress && onKeyPress(event)}
            readOnly={readOnly}
          />
        </InputGroup>
      </div>
      {errorMessage && errorMessage !== '' && <span className="error-msg">{errorMessage}</span>}
    </div>
  );
};

export default CWInputGroup;
